import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { UserProfile } from '../../../models/Profile'
import ProfileService from '../../../services/ProfileService'
import WorkplaceFooter from '../../common/WorkplaceFooter'
import { LoaderProvider } from '../../context/FormLoader'
import Protected from '../../Protected'
import LeaveResults from './LeaveResults'
import NoticeRedundancyResults from './NoticeRedundancyResults'
import PayResults from './PayResults'
import ResultsInfo from './ResultsInfo'
import ShiftResults from './ShiftResults'

const Results = () => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const { getCurrentUserProfile } = ProfileService

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    fetchCurrentUserProfile(source)
      .then((profile) => {
        if (mountedRef.current) {
          setUserProfile(profile)
        }
      })
      .finally(() => {
        if (mountedRef.current) {
          setIsLoading(false)
        }
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const fetchCurrentUserProfile = async (source: CancelTokenSource) => {
    return await getCurrentUserProfile(source).then((response) => {
      return response.result
    })
  }
  return (
    <Protected>
      <LoaderProvider>
        <div className="content-wrapper">
          <article className="main">
            <ResultsInfo />
            <p></p>
            <PayResults />

            <p></p>
            <ShiftResults />
            <p></p>
            <LeaveResults />
            <p></p>
            <NoticeRedundancyResults />
          </article>
        </div>
      </LoaderProvider>
      <p></p>
      <WorkplaceFooter userProfile={userProfile} isLoading={isLoading} />
    </Protected>
  )
}

export default Results
